export const allowedReactions = [
  ':+1:',
  ':-1:',
  ':heart:',
  ':cry:',
  ':tada:',
]
